/** @format */
import { DataLayerRiskifiedEventType } from '@toucan/client/global/analytics';

import { trackViaDataLayer } from '@toucan/client/shared/helpers/analytics';

import { RISKIFIED_KEY_PAGES } from './constants';

export const getRiskifiedKeyPage = (pathname: string): string | null => {
    return (
        RISKIFIED_KEY_PAGES.find((route) => route.pattern.test(pathname))
            ?.pageName || null
    );
};

export const trackPageViewForRiskified = (pathname: string) => {
    const keyPage = getRiskifiedKeyPage(pathname);

    if (!keyPage) {
        return;
    }

    window.RISKX?.go(keyPage);

    trackViaDataLayer({
        event: DataLayerRiskifiedEventType.BEACON_TRIGGERED_ON_ROUTE_CHANGE,
        page: keyPage,
    });
};
